module.exports = __webpack_public_path__ + "img/sentinel-small-dark.f5cf89b2.svg";